<template>
  <div>
    <Alert
      v-for="[type, message] in alerts"
      :key="type"
      :type="type"
      class="tw-rounded-none"
    >
      <template #title>
        {{ message }}
      </template>
    </Alert>
  </div>
</template>

<script setup>
import Alert from './Alert.vue'
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const page = usePage()

const alerts = computed(() => {
  if (!page.props.flash) return {}
  return Object.entries(page.props.flash).filter(([, message]) => {
    return !!message
  })
})
</script>
